import { render, staticRenderFns } from "./EntradasView.vue?vue&type=template&id=37f9d72e&"
import script from "./EntradasView.vue?vue&type=script&lang=js&"
export * from "./EntradasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports